module.exports = __webpack_public_path__ + "static/media/Modules2.f0d94110.svg";